import API from './api';
import React from 'react';
import Swipe from 'swipejs';
import Modal from 'react-modal';
import {Search, SimpleSearch} from './search';
import {ReviewButton} from './review';
import LoginPrompt from './login';
import {render} from 'react-dom';
import moment from 'moment-timezone';

Modal.setAppElement('#modal');

function setupTooltips() {
  Array.from(document.querySelectorAll('.has-tooltip')).map((el) => {
    el.addEventListener('mouseenter', () => {
      let tooltip = document.createElement('div');
      tooltip.className = 'tooltip';
      tooltip.innerHTML = el.dataset.tip;
      el.appendChild(tooltip);
    });
    el.addEventListener('mouseleave', () => {
      let tooltip = el.querySelector('.tooltip');
      el.removeChild(tooltip);
    });
  });
}

function bindClick(sel, fn) {
  Array.from(document.querySelectorAll(sel)).map((el) => {
    el.addEventListener('click', fn);
  });
}

function saveCallCard() {
  let id = parseInt(this.dataset.id);
  API.post('/creatives/save', {id: id}, () => {
    this.querySelector('span').setAttribute('class', 'icon-bookmark');
    this.style.display = 'block';
    this.removeEventListener('click', saveCallCard);
    this.addEventListener('click', unsaveCallCard);
  });
}

function unsaveCallCard() {
  let id = parseInt(this.dataset.id);
  API.delete('/creatives/save', {id: id}, () => {
    this.querySelector('span').setAttribute('class', 'icon-bookmark-add');
    this.style.display = '';
    this.removeEventListener('click', unsaveCallCard);
    this.addEventListener('click', saveCallCard);
  });
}

function saveCall() {
  let id = parseInt(this.dataset.id);
  API.post('/creatives/save', {id: id}, () => {
    this.innerHTML = 'Saved';
    this.removeEventListener('click', saveCall);
    this.addEventListener('click', unsaveCall);
  });
}

function unsaveCall() {
  let id = parseInt(this.dataset.id);
  API.delete('/creatives/save', {id: id}, () => {
    this.innerHTML = 'Save this call';
    this.removeEventListener('click', unsaveCall);
    this.addEventListener('click', saveCall);
  });
}

function saveOrgCard() {
  let id = parseInt(this.dataset.id);
  API.post('/creatives/follow', {id: id}, () => {
    this.querySelector('span').setAttribute('class', 'icon-bookmark');
    this.style.display = 'block';
    this.removeEventListener('click', saveOrgCard);
    this.addEventListener('click', unsaveOrgCard);
  });
}

function unsaveOrgCard() {
  let id = parseInt(this.dataset.id);
  API.delete('/creatives/follow', {id: id}, () => {
    this.querySelector('span').setAttribute('class', 'icon-bookmark-add');
    this.style.display = '';
    this.removeEventListener('click', unsaveOrgCard);
    this.addEventListener('click', saveOrgCard);
  });
}

function saveOrg() {
  let id = parseInt(this.dataset.id);
  API.post('/creatives/follow', {id: id}, () => {
    this.innerHTML = 'Unfollow';
    this.removeEventListener('click', saveOrg);
    this.addEventListener('click', unsaveOrg);
  });
}

function unsaveOrg() {
  let id = parseInt(this.dataset.id);
  API.delete('/creatives/follow', {id: id}, () => {
    this.innerHTML = 'Follow';
    this.removeEventListener('click', unsaveOrg);
    this.addEventListener('click', saveOrg);
  });
}

bindClick('.js-save-call-card', saveCallCard);
bindClick('.js-unsave-call-card', unsaveCallCard);
bindClick('.js-save-call', saveCall);
bindClick('.js-unsave-call', unsaveCall);
bindClick('.js-save-org-card', saveOrgCard);
bindClick('.js-unsave-org-card', unsaveOrgCard);
bindClick('.js-save-org', saveOrg);
bindClick('.js-unsave-org', unsaveOrg);

let swipe = Swipe(document.getElementById('slider'), {
  auto: 6000,
  speed: 800
});
if (swipe) {
  bindClick('.js-swipe-prev', swipe.prev);
  bindClick('.js-swipe-next', swipe.next);
}

const searchEl = document.getElementById('search');
if (searchEl) {
  render(<Search />, searchEl);
}

const simpleSearchEl = document.getElementById('search-simple');
if (simpleSearchEl) {
  render(<SimpleSearch />, simpleSearchEl);
}

const reviewEl = document.getElementById('review-form');
if (reviewEl) {
  let id = reviewEl.dataset.id;
  let text = reviewEl.dataset.text;
  render(<ReviewButton text={text} id={id} />, reviewEl);
}


bindClick('.js-login-prompt', () => {
  const el = document.getElementById('login-prompt');
  render(<LoginPrompt el={el} />, el);
});


setTimeout(() => {
  let el = document.getElementById('flashes');
  if (el) {
    el.parentNode.removeChild(el);
  }
}, 5000);


setupTooltips();

// Convert to user timezone
// Moment automatically formats in local timezone
Array.from(document.querySelectorAll('time')).map((el) => {
  // Assume all saved datetimes are UTC
  let dt = moment(el.getAttribute('datetime')+'Z');
  let tz = moment.tz(moment.tz.guess()).format('z');
  el.innerText = `${dt.format('MMMM Do YYYY, H:mm:ss')} ${tz}`;
});



// WEBPACK FOOTER //
// ./res/front/static/js/main.js